var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.592 0a12 12 0 1012 12 12.013 12.013 0 00-12-12zm-4 7a2 2 0 110 4 2 2 0 010-4zm-.941 8.709a.438.438 0 01.379-.22h9.123a.44.44 0 01.38.658 5.707 5.707 0 01-9.882 0 .436.436 0 010-.438zm11.587-5.274a1.001 1.001 0 01-1.29-.58A1.207 1.207 0 0016.883 9a1.207 1.207 0 00-1.065.856.999.999 0 01-1.622.372 1 1 0 01-.248-1.084 3.08 3.08 0 015.87 0 1 1 0 01-.58 1.291z",
    fill: "#718FBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiOpen);
export default __webpack_public_path__ + "static/media/emoji-open.12fbc19bbd30a18c093859b3376993b9.svg";
export { ForwardRef as ReactComponent };